import React, { useState } from "react";

import {
  Button,
  CustomInput,
  Form,
  FormGroup,
  Input,
  Label,
  UncontrolledAlert,
} from "reactstrap";

import { faBell } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { twoFAApi } from "../../services/twoFAServices";
import Loader from "../Loader";
import InformationModal from "../InformationModal";

const TwoFAForm = ({
  onComplete,
  onBack,
  message,
  userId,
  isSetup = false,
}) => {
  const [oneTimePassword, setOneTimePassword] = useState("");
  const [remember, setRemember] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [lostDeviceModal, setLostDeviceModal] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(false);
    try {
      const result = await twoFAApi.verify({
        token: oneTimePassword,
        userId,
        remember,
      });
      onComplete(result);
    } catch (err) {
      // The API answers verify failures, including the lockout after too many
      // attempts, with `message`.
      setError(
        err.response?.data?.message ||
          err.response?.data?.msg ||
          "There was an error, please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Form onSubmit={onSubmit}>
        <FormGroup>
          {message ? (
            <Label for="otpUser">{message}</Label>
          ) : (
            <Label for="otpUser">Enter your one-time password</Label>
          )}
          <Input
            id="otpUser"
            maxLength="10"
            required
            bsSize="lg"
            name="otp"
            type="text"
            placeholder="6-digit code"
            value={oneTimePassword}
            onChange={(e) => setOneTimePassword(e.currentTarget.value.trim())}
          />
        </FormGroup>
        {!isSetup ? (
          <FormGroup>
            <CustomInput
              type="checkbox"
              id="rememberDevice"
              checked={remember}
              onChange={(e) => setRemember(e.target.checked)}
              label="Remember this device"
            />
          </FormGroup>
        ) : null}
        <div className="text-center mt-3">
          <UncontrolledAlert
            isOpen={!!error}
            toggle={() => setError(false)}
            color="warning"
          >
            <div className="alert-icon">
              <FontAwesomeIcon icon={faBell} fixedWidth />
            </div>
            <div className="alert-message text-left">
              <span className="ml-2">{error}</span>
            </div>
          </UncontrolledAlert>
          {loading ? (
            <Loader size="sm" />
          ) : (
            <div className="d-flex">
              <Button
                color="secondary"
                onClick={onBack}
                size="lg"
                className="mr-2"
                type="button"
              >
                Back
              </Button>
              <Button
                color="primary"
                type="submit"
                size="lg"
                className="flex-grow-1"
              >
                Confirm
              </Button>
            </div>
          )}
        </div>
        {!isSetup ? (
          <div className="mt-3 text-center">
            <small
              className="text-muted"
              style={{ cursor: "pointer", textDecoration: "underline" }}
              onClick={() => setLostDeviceModal(true)}
            >
              Lost your device?
            </small>
          </div>
        ) : null}
      </Form>
      {lostDeviceModal ? (
        <InformationModal
          title="2FA Device Lost"
          body={
            <span>
              If you lost your 2FA device please contact support at{" "}
              <a href="mailto:support@benparker.com">support@benparker.com</a>
            </span>
          }
          rawBody={true}
          onClose={() => setLostDeviceModal(false)}
        />
      ) : null}
    </>
  );
};

export default TwoFAForm;
